var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testDialog"},[_c('h1',[_vm._v("弹出dialog")]),_vm._v(" "),_c('iframe',{attrs:{"id":"show-iframe","frameborder":"0","name":"showHere","scrolling":"auto","src":_vm.dialogHref}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-595ca416","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/websocketdialog/callDialog.vue
// module id = null
// module chunks = 